export default __webpack_public_path__ + "static/media/Icons_17.f2cf2b68.svg";